<template>
    <d-card class="mt-3 mb-3" sm="12">
        <d-card-header class="pb-0 mb-3 font-weight-bold">Report settings</d-card-header>
        <d-card-body class="py-0">
            <div class="notification__icon-wrapper">
                <div class="form-group">
                    <label>E-mail approval reports (max. 1 per day) &nbsp;</label>&nbsp;&nbsp;
                    <toggle-button
                        v-model="configurations['approval-daily']"
                        :labels="true"
                        :sync=true
                        @change="changeReportConfiguration($event, 'approval-daily')"
                    />
                </div>
                <div class="form-group">
                    <label>Get a daily report on email &nbsp;</label>&nbsp;&nbsp;
                    <toggle-button
                        v-model="configurations['imported-daily']"
                        :labels="true"
                        :sync=true
                        @change="changeReportConfiguration($event, 'imported-daily')"
                    />
                </div>
                <div class="form-group">
                    <label>Get a weekly report on email &nbsp;</label>&nbsp;&nbsp;
                    <toggle-button
                        v-model="configurations['imported-weekly']"
                        :labels="true"
                        :sync=true
                        @change="changeReportConfiguration($event, 'imported-weekly')"
                    />
                </div>
                <div class="form-group">
                    <label>Get a monthly report on email &nbsp;</label>&nbsp;&nbsp;
                    <toggle-button
                        v-model="configurations['imported-monthly']"
                        :labels="true"
                        :sync=true
                        @change="changeReportConfiguration($event, 'imported-monthly')"
                    />
                </div>
            </div>
        </d-card-body>
    </d-card>
</template>

<script>
import EmailReportingConfigurationsResource from "../../resources/EmailReportingConfigurationsResource"
import notification from '@/mixins/notification';

export default {
    mixins: [notification],

    props: {
        websiteId: {
            required: true
        },
    },

    data() {
        return {
            isEnabledSendDailyReportsOnEmailByCustomer: false,
            configurations: {},
            configurations1: {
                'approval-daily': false,
                'imported-daily': false,
                'imported-weekly': false,
                'imported-monthly': false,
            },
        }
    },

    methods: {
        async changeReportConfiguration(event, name) {
            await EmailReportingConfigurationsResource.apply(
                this.websiteId,
                name,
                event.value
            )

            this.showNotification('success', 'Alert', 'Changes are saved!')
        },

        async init() {
            let configurations = await EmailReportingConfigurationsResource.get(this.websiteId)
            this.configurations = configurations.data
        },
    },

    async created() {
        await this.init()
    },

    watch: {
        async $route(to, from) {
            await this.init()
        }
    },
}
</script>
